import { useState } from "react";

// Custom Hook for handling modal logic
export const useModal = () => {
  const [isOpen, setIsOpen] = useState(false);

  const openModal = (value) => setIsOpen(value ||true);
  const closeModal = () => setIsOpen(false);

  return {
    isOpen,
    openModal,
    closeModal,
  };
};
